import { useRouteMatch, useQueryParams } from '@fs/zion-router'

export default function useBrightspotPreviewId(routeMatchPath) {
  const routeMatch = useRouteMatch(routeMatchPath)
  const { query } = useQueryParams()
  const { previewId } = query
  return previewId || routeMatch?.url
}
